import { useBlocker } from "react-router-dom";
import { useEffect } from "react";

import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import Header from "../Navigation/Header/Header";
import MainToolbarReports from "@/appComponents/Navigation/MainToolbar/MainToolbarReports";
import ReportModal from "@/appComponents/Blocks/Modals/TableResultsModal/ReportModal";
import { RightSidebar } from "@/appComponents/Navigation/RightSidebar/RightSidebar";
import { RightSidebarSlot } from "@/appComponents/Blocks/Composites/AppLayout/RightSidebarSlot";
import { useReportingContext } from "@/providers/ReportsProvider";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { appstr } from "@coreapp/utils/appstr";
import { MainContainer } from "../Blocks/Utils/MainContainer";

const ReportsPage = () => {
  const ctx = useWSMgrContext();
  const wsMgr = ctx.wsMgr.state;

  const { isOpenReportDirty, SaveReportChanges } = useReportingContext();
  const blocker = useBlocker(isOpenReportDirty);

  useEffect(() => {
    if (blocker.state !== "blocked") {
      return;
    }

    wsMgr?.CreateReactAlert(
      appstr("saveandcontinue"),
      appstr("genericsave"),
      async () => {
        await SaveReportChanges();
        blocker.proceed();
      },
      blocker.proceed,
      appstr("Save Changes"),
      appstr("Discard Changes"),
      blocker.reset
    );
  }, [blocker.state]);

  return (
    <>
      <div className="appHeader">
        <Header />
        <div className="mainToolBar">
          <MainToolbarReports />
        </div>
      </div>
      <CentralizedModalContainer show={true}>
        <MainContainer>{<ReportModal />}</MainContainer>
      </CentralizedModalContainer>
      <RightSidebarSlot>
        <RightSidebar />
      </RightSidebarSlot>
    </>
  );
};

export default ReportsPage;
